// extracted by mini-css-extract-plugin
export default {"menu-item":"tasks-assignments_component_menu-item__-qY+0"};